import React, { useState } from "react";
import "./vendorForm.css";
import { supabase } from "../supabaseClient";

const VendorExtrasForm = () => {
  const [vendorEmail, setVendorEmail] = useState("");
  const [extraWristbands, setExtraWristbands] = useState(0);
  const [wantsHay, setWantsHay] = useState(false);
  const [hayBales, setHayBales] = useState(0);
  const [formFile, setFormFile] = useState([]); // indemnity form
  const [selfInsurance, setSelfInsurance] = useState([]); // optional insurance form
  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Submitting...");

    try {
      setStatus("Fetching vendor brand...");

      // 1️⃣ Get brand name from email
      const { data: vendorData, error: vendorErr } = await supabase
        .from("xmas_vendors_2025")
        .select("brand_name")
        .eq("email_address", vendorEmail)
        .single();

      if (vendorErr) throw vendorErr;
      if (!vendorData) throw new Error("Vendor not found.");

      const vendorBrandName = vendorData.brand_name;
      const safeBrandName = vendorBrandName.replace(/[^a-zA-Z0-9._-]/g, "_");

      setStatus("Uploading files...");

      const fileUrls = [];
      if (formFile.length > 0) {
        for (const file of formFile) {
          const safeFileName = file.name.replace(/[^a-zA-Z0-9._-]/g, "_");
          const fileName = `${safeBrandName}-${safeFileName}`;

          const { error } = await supabase.storage
            .from("vendor_form")
            .upload(fileName, file, { upsert: true });

          if (error) throw error;

          const { data: publicUrlData } = supabase.storage
            .from("vendor_form")
            .getPublicUrl(fileName);

          fileUrls.push(publicUrlData.publicUrl);
        }
      }

      // 🟡 Upload self-insurance form (optional — skip silently if not uploaded)
      const insuranceUrls = [];
      if (selfInsurance && selfInsurance.length > 0) {
        for (const file of selfInsurance) {
          try {
            const safeFileName = file.name.replace(/[^a-zA-Z0-9._-]/g, "_");
            const fileName = `${safeBrandName}-insurance-${safeFileName}`;

            const { error } = await supabase.storage
              .from("vendor_form")
              .upload(fileName, file, { upsert: true });

            if (error) throw error;

            const { data: publicUrlData } = supabase.storage
              .from("vendor_form")
              .getPublicUrl(fileName);

            insuranceUrls.push(publicUrlData.publicUrl);
          } catch (innerErr) {
            console.warn("Optional insurance upload skipped:", innerErr.message);
          }
        }
      }

      // 2️⃣ Insert or update extras
      const { error: insertError } = await supabase.from("vendor_extras").upsert(
        {
          vendor_email: vendorEmail,
          extra_wristbands: extraWristbands,
          wants_hay: wantsHay,
          hay_bales: hayBales,
          form_url: fileUrls.length > 0 ? JSON.stringify(fileUrls) : null,
          insurance_form_url:
            insuranceUrls.length > 0 ? JSON.stringify(insuranceUrls) : null,
          has_uploaded_form: fileUrls.length > 0 || insuranceUrls.length > 0,
        },
        { onConflict: "vendor_email" }
      );

      if (insertError) throw insertError;
      setStatus("✅ Submitted successfully!");
    } catch (err) {
      console.error(err);
      setStatus("❌ Submission failed: " + err.message);
    }
  };

  return (
    <div className="vendor-form-container">
      <div className="vendor-form-card">
        <h2>Vendor Extras</h2>

        <form onSubmit={handleSubmit}>
          <label>Email (use Email you applied with)</label>
          <input
            type="email"
            required
            value={vendorEmail}
            onChange={(e) => setVendorEmail(e.target.value)}
          />

          <label>Extra Wristbands(optional) @300 ksh each</label>
          <input
            type="number"
            min="0"
            value={extraWristbands}
            onChange={(e) => setExtraWristbands(Number(e.target.value))}
          />

          <div className="checkbox-row">
            <input
              type="checkbox"
              id="wantsHay"
              checked={wantsHay}
              onChange={(e) => setWantsHay(e.target.checked)}
            />
            <label htmlFor="wantsHay">I would like to request hay bales</label>
          </div>

          {wantsHay && (
            <>
              <label>Number of Hay Bales @500 ksh Each</label>
              <input
                type="number"
                min="0"
                value={hayBales}
                onChange={(e) => setHayBales(Number(e.target.value))}
              />
            </>
          )}

          <label>Upload Indemnity Form (PDF or image)</label>
          <input
            type="file"
            accept=".pdf,image/*"
            multiple
            required
            onChange={(e) => setFormFile(Array.from(e.target.files))}
          />

          <label>Upload Self-insurance Form (optional)</label>
          <input
            type="file"
            accept=".pdf,image/*"
            multiple
            onChange={(e) => setSelfInsurance(Array.from(e.target.files))}
          />

          <button type="submit">Submit</button>
        </form>

        {status && (
          <p
            className={`status-message ${
              status.startsWith("✅") ? "success" : "error"
            }`}
          >
            {status}
          </p>
        )}
      </div>
    </div>
  );
};

export default VendorExtrasForm;